import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { AnimatePresence, motion } from 'motion/react';
import { isNil } from '@grandvisionhq/utils';

const variants = {
    enter: ({ index  })=>({
            y: 0,
            opacity: 1,
            transition: {
                delay: index * 0.05,
                duration: 0.2,
                ease: 'easeIn'
            }
        })
    ,
    exit: {
        y: 10,
        opacity: 0
    }
};
var RadioButtonGroupWithContent = (_param)=>{
    var { initialValue , onChange , value  } = _param, props = swcHelpers.objectWithoutProperties(_param, [
        "initialValue",
        "onChange",
        "value"
    ]);
    const initialSelectedValue = value ? value : initialValue;
    const [selectedValue, setSelectedValue] = React.useState(initialSelectedValue || '');
    const handleChange = React.useCallback((item)=>{
        if (!item.disabled) {
            const newSelectedValue = item.value;
            setSelectedValue(newSelectedValue);
            onChange(newSelectedValue);
        }
    }, [
        onChange
    ]);
    React.useEffect(()=>{
        /**
     * On mount:
     * 1. check is there is a default `value`
     * 2. Check if the default `value` also exists in the items array
     * If condition 1 and 2 are met, call the onChange callBack fn
     */ if (!isNil(value) && props.items.some((item)=>item.value === value
        )) {
            onChange(value);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    React.useEffect(()=>{
        if (!isNil(value)) {
            setSelectedValue(value);
        }
    }, [
        value
    ]);
    const { items , scope , className , hasError  } = props;
    const classNames = classnames('radio-button-group-with-content', className);
    return /*#__PURE__*/ React.createElement("ul", {
        className: classNames,
        "data-t": props['data-t'],
        role: "radiogroup"
    }, /*#__PURE__*/ React.createElement(AnimatePresence, null, items.length > 0 && items.map((item, index)=>/*#__PURE__*/ React.createElement(motion.li, {
            className: "radio-button-group-with-content__item",
            key: `${item.value}-${index}`,
            custom: {
                index
            },
            variants: variants,
            initial: "exit",
            animate: "enter",
            role: "presentation"
        }, /*#__PURE__*/ React.createElement("div", {
            className: classnames('radio-button-group-with-content__container', {
                'radio-button-group-with-content__container--disabled': item.disabled && item.value !== selectedValue,
                'radio-button-group-with-content__container--checked': item.value === selectedValue,
                'radio-button-group-with-content__container--error': hasError
            })
        }, /*#__PURE__*/ React.createElement("label", {
            className: classnames('radio-button-group-with-content__label', {
                'radio-button-group-with-content__label--disabled': item.disabled && item.value !== selectedValue,
                'radio-button-group-with-content__label--error': hasError
            })
        }, /*#__PURE__*/ React.createElement("input", {
            className: "radio-button-group-with-content__input",
            name: scope,
            "data-t": item.value,
            type: "radio",
            value: item.value,
            checked: item.value === selectedValue,
            "aria-checked": item.value === selectedValue,
            disabled: item.disabled && item.value !== selectedValue,
            onChange: ()=>handleChange(item)
        }), /*#__PURE__*/ React.createElement("div", {
            className: classnames('radio-button-group-with-content__radio', {
                'radio-button-group-with-content__radio--disabled': item.disabled,
                'radio-button-group-with-content__radio--checked': item.value === selectedValue,
                'radio-button-group-with-content__radio--error': hasError
            })
        }), /*#__PURE__*/ React.createElement("div", {
            className: "radio-button-group-with-content__text"
        }, /*#__PURE__*/ React.createElement("span", null, item.label), item.subtext && /*#__PURE__*/ React.createElement("span", {
            className: "radio-button-group-with-content__subtext"
        }, item.subtext)), item.aside && /*#__PURE__*/ React.createElement("span", {
            className: "radio-button-group-with-content__aside"
        }, item.aside)), item.content && item.value === selectedValue && /*#__PURE__*/ React.createElement("div", {
            className: classnames('radio-button-group-with-content__content', {
                'radio-button-group-with-content__content--disabled': item.disabled && item.value !== selectedValue,
                'radio-button-group-with-content__content--error': hasError
            })
        }, item.content)))
    )));
};

export { RadioButtonGroupWithContent };
//# sourceMappingURL=RadioButtonGroupWithContent.js.map
